type DepositAmountFields = {
  amount?: number | null
  percent?: number | null
}

export const getAmountFromDeposit = (
  deposit?: DepositAmountFields,
  salePrice?: number
) => {
  if (deposit?.amount != null) return deposit.amount
  if (deposit?.percent != null && salePrice != null) {
    return (deposit.percent / 100) * salePrice
  }

  return 0
}

export const getTotalDepositAmount = ({
  initialDeposit,
  balanceDeposit,
  salePrice,
}: {
  initialDeposit?: DepositAmountFields
  balanceDeposit?: DepositAmountFields
  salePrice?: number
}) =>
  getAmountFromDeposit(initialDeposit, salePrice) +
  getAmountFromDeposit(balanceDeposit, salePrice)
